var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 22C12.635 22 12.442 21.9357 12.2834 21.8167L8.61669 19.0667C8.50284 18.9813 8.41044 18.8706 8.3468 18.7433C8.28316 18.616 8.25002 18.4756 8.25002 18.3333V13.1817L1.81869 5.94642C1.36193 5.43114 1.0637 4.79491 0.959846 4.11421C0.855988 3.43351 0.950922 2.7373 1.23324 2.10926C1.51555 1.48122 1.97323 0.948071 2.55127 0.573894C3.12931 0.199717 3.80311 0.000434884 4.49169 0L17.5084 0C18.1969 0.00080763 18.8705 0.200419 19.4483 0.574848C20.0261 0.949276 20.4835 1.48259 20.7655 2.1107C21.0475 2.73882 21.1422 3.435 21.0381 4.1156C20.9339 4.7962 20.6355 5.43226 20.1786 5.94733L13.75 13.1817V21.0833C13.75 21.3264 13.6534 21.5596 13.4815 21.7315C13.3096 21.9034 13.0765 22 12.8334 22ZM10.0834 17.875L11.9167 19.25V12.8333C11.9169 12.6089 11.9994 12.3923 12.1486 12.2247L18.8109 4.72908C19.0331 4.47799 19.1781 4.16812 19.2284 3.83666C19.2788 3.50521 19.2324 3.16626 19.0949 2.86051C18.9574 2.55476 18.7345 2.2952 18.4531 2.113C18.1716 1.93079 17.8436 1.83369 17.5084 1.83333H4.49169C4.1566 1.83384 3.82878 1.931 3.54753 2.11316C3.26628 2.29532 3.04355 2.55474 2.90605 2.86032C2.76855 3.1659 2.72212 3.50465 2.77232 3.83596C2.82253 4.16726 2.96724 4.47705 3.18911 4.72817L9.85236 12.2247C10.0012 12.3925 10.0834 12.609 10.0834 12.8333V17.875Z",
    fill: "#ACB0B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9d546af9f12653cd651340293c934359.svg";
export { ForwardRef as ReactComponent };